export interface UnpaidHubProductDefinition {
  key: string;
  label: string;
  logoUrl: string;
  routeSegment: string;
}

export const UNPAID_HUB_PRODUCTS: UnpaidHubProductDefinition[] = [
  { key: 'denefits', label: 'Denefits', logoUrl: '/Denefits.svg', routeSegment: 'denefits' },
  { key: 'credee', label: 'Credee', logoUrl: '/Credee.svg', routeSegment: 'credee' },
  { key: 'lendee', label: 'Lendee', logoUrl: '/Lendee.svg', routeSegment: 'lendee' },
  { key: 'recuvery', label: 'Recuvery', logoUrl: '/Recovery.svg', routeSegment: 'recuvery' },
  { key: 'fm', label: 'Finance Mutual', logoUrl: '/FinanceMutual.svg', routeSegment: 'fm' },
];

/** Default FM list filter per product (hub overview + list APIs). */
export const DEFAULT_FM_FILTER_BY_PRODUCT: Readonly<Record<string, number>> = {
  credee: 0,
  fm: 0,
  recuvery: 5,
};

export function getDefaultFmFilter(productKey: string): number {
  return DEFAULT_FM_FILTER_BY_PRODUCT[productKey] ?? 0;
}
